import React from "react";
//#region redux
//#endregion
//#region types
import { NumberInputProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { CommonConstants, CustomerConstants, IconDefinitionConstants } from "utils/constants";
import { TaxInformationSectionProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { HorizontalFormField, GroupSection, NumberInput, TextInput } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const RutRotSettingsSection: React.FC<TaxInformationSectionProps> = ({ connect }) => {
  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutRotDescription)}
      icon={IconDefinitionConstants.WVat}
      navKey={CustomerConstants.SettingsNavKeys.HouseWork}
    >
      <HorizontalFormField<TextInputProps>
        Component={TextInput}
        {...connect("rutRotSettings.propertyDesignation")}
        label={TranslationKeys.Invoice.PropertyDesignation}
        descriptionText={TranslationKeys.Invoice.PropertyDesignationDescription}
        maxLength={40}
        optional
      />
      <HorizontalFormField<NumberInputProps>
        Component={NumberInput}
        {...connect("rutRotSettings.tenantsOwnerAssociationOrgNumber")}
        label={TranslationKeys.Invoice.TenantsOrgNumber}
        allowLeadingZeros
        format={CommonConstants.OrganizationNumberMask}
        optional
      />
      <HorizontalFormField<TextInputProps>
        Component={TextInput}
        {...connect("rutRotSettings.apartmentNumber")}
        label={TranslationKeys.Invoice.ApartmentNumber}
        optional
      />
    </GroupSection>
  );
};

export default RutRotSettingsSection;
